export default "__VITE_ASSET__BxHOL3j3__"